import React from 'react';
import formFieldType, { formFieldText } from '@/forms/helper';
import { states } from '@/constants/lifecycle';
import FormFieldList from '@/forms/components/FormFieldList';
import selectors from '../hooks/selectors';
import fieldComponents from '../fields';

const RequestFieldList = ({ category, code, section }) => {
  const { request, fields } = selectors.useRequestFieldList({ category, code, section });

  return (
    <FormFieldList
      category={category}
      className="aridhia-request-field-list"
      code={code}
      component={(f) => fieldComponents[formFieldType(f)]}
      fields={fields}
      saveErrors={[]}
      saveStatus={states.NONE}
      section={section}
      text={(f) => formFieldText(request, f, 'fields.')}
    />
  );
};

export default RequestFieldList;
